// extracted by mini-css-extract-plugin
export default {"Video":"styles_Video__B1h0T","playButton":"styles_playButton__R5e7n"};